import { useCallback } from 'react';

import { useConfigTag } from '@interlayer/js/app/hooks/useConfigTag';
import { useRegistrationSelector } from '@interlayer/js/app/store/hooks/useRegistrationSelector';
import { CONFIG_TAG_TYPE } from '@interlayer/js/components/system/TagManager/buzz/constants';

export const useGetOccupationTags = () => {
    const { occupationSuggestions } = useRegistrationSelector();
    const occupationConfig = useConfigTag(CONFIG_TAG_TYPE.occupationConfig);
    const { config: { additionalOccupationOptions = [] } = {} } = occupationConfig || {};

    return useCallback((occupation) => {
        const splitOccupation = occupation.split('-')[0].trim();
        const customOccupation = additionalOccupationOptions.find(({ option }) => option === splitOccupation);

        if (customOccupation) {
            if (customOccupation.tag) {
                return customOccupation.tag.split(',').map((tag) => ({ name: tag.trim() }));
            }

            return [];
        }

        const { tagsList } = occupationSuggestions.find(({ suggestion }) => suggestion === occupation) || {};

        if (tagsList?.length) {
            return tagsList.map((tag) => ({ name: tag }));
        }

        return [];
    }, [additionalOccupationOptions, occupationSuggestions]);
};
